import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import SectorPage from "./SectorPage";
import Cover from "images/CareerFields/psychology-cover_2560.webp";
import Icon1 from "images/hospital.svg";
import Icon2 from "images/world.svg";
import Icon3 from "images/handshake.svg";
import Icon4 from "images/house.svg";
import Image1 from "images/psychology-image1_2560.webp";
import Image2 from "images/psychology-image2_2560.webp";

const bulletPoints = [
  { icon: Icon1, text: "Hands-on experience in global mental health" },
  { icon: Icon2, text: "Cross-cultural understanding of mental health" },
  { icon: Icon3, text: "Community engagement and meaningful impact" },
  { icon: Icon4, text: "Comprehensive package with food and accommodation" },
];

const Psychology = () => {
  const i18nLocale = useSelector((state) => state.i18nLocale);

  const intro = (
    <>
      <strong>
        Are you a psychology student or graduate looking for a transformative
        experience in Tanzania?
      </strong>{" "}
      Join Health Mission Africa's Psychology Program and gain practical
      exposure in cross-cultural mental health settings in Arusha. Work
      alongside local professionals, observe real-world practice, and broaden
      your understanding of mental health within a resource-limited healthcare
      system.
    </>
  );

  const textOne = (
    <p>
      Our program offers both students and graduates the opportunity to apply
      their theoretical knowledge in a practical setting, helping them develop
      essential skills and confidence while engaging in mental health support,
      community programs, and psychological practice.
      <br />
      <br />
      Volunteers are immersed in a unique system that differs from their home
      countries. With limited resources, participants will witness firsthand the
      challenges and resilience involved in providing psychological support in
      resource-constrained environments. This experience will broaden your
      perspective and strengthen your adaptability as a mental health
      professional.
      <br />
      <br />
      <strong>What You'll Gain</strong>
      <ul style={{ paddingLeft: "20px", lineHeight: "2.2" }}>
        <li>Exposure to clinical and community mental health</li>
        <li>Cross-cultural insight and professional growth</li>
        <li>Experience in diverse psychological settings</li>
        <li>Mentorship from local professionals</li>
        <li>A deeper understanding of global mental health challenges</li>
      </ul>
      <br />
      <strong>Program Overview &amp; Placement Opportunities</strong>
      <br />
      <br />
      Our psychology placements are built on collaboration and respect.
      Volunteers work alongside local professionals, contributing appropriately
      within their level of training while learning from the cultural and
      clinical environment. Every participant receives a personalized placement
      plan based on their background and goals.
      <br />
      <br />
      Depending on your interests, experience, and professional goals,
      participants may be placed in a variety of settings including clinical
      psychology placements within a regional hospital, children and youth
      support programs, women's empowerment initiatives, substance use recovery
      programs, psychoeducation or community mental health outreach projects,
      and workshop development projects.
      <br />
      <br />
      For a detailed description of each placement setting and the type of
      activities involved, please visit our{" "}
      <Link
        to={`/${i18nLocale}/career_fields/psychology/psychology_placement`}
        style={{ color: "inherit" }}
      >
        <u>psychology placement opportunities</u>
      </Link>{" "}
      page.
    </p>
  );

  const textTwo = (
    <p>
      <strong>Comprehensive Program Package</strong>
      <br />
      <br />
      As part of our program, we provide:
      <ul style={{ paddingLeft: "20px", lineHeight: "2.2" }}>
        <li>Secure accommodation</li>
        <li>Daily breakfast and dinner</li>
        <li>Daily housekeeping</li>
        <li>Orientation day</li>
        <li>Airport pick-up and drop-off</li>
        <li>Internship and volunteering placement assistance</li>
        <li>Continuous support throughout your stay</li>
      </ul>
      <br />
      <strong>Beyond the Placement</strong>
      <br />
      <br />
      But it's not just about the clinical experience. Our volunteers also have
      the opportunity to immerse themselves in Tanzanian culture and experience
      the beauty of the country. We offer assistance in organising activities
      such as safaris, trips to Zanzibar, Mount Kilimanjaro climb, hot springs
      day trips, local markets visits, and other cultural activities.
      <br />
      <br />
      By combining professional development with cultural experiences,
      HealthMission Africa offers a comprehensive, immersive program that is
      unmatched in its scope and impact. Join us and experience the adventure of
      a lifetime while making a positive impact on the lives of others.
      <br />
      <br />
      If you are motivated, culturally open-minded, and eager to grow both
      personally and professionally, we would be happy to speak with you. Apply
      now and schedule a call with our team to learn more.
    </p>
  );

  return (
    <SectorPage
      cover={Cover}
      title={"Psychology"}
      intro={intro}
      bulletPoints={bulletPoints}
      textOne={textOne}
      textTwo={textTwo}
      imageOne={Image1}
      imageTwo={Image2}
    />
  );
};

export default Psychology;
